export default "__VITE_PUBLIC_ASSET__b18f8096__"